import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import PasswordInput from '../components/PasswordInput';
import { useAuth } from '../context/AuthContext';
import './Auth.scss';

const ReinitialisationMotDePasse = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { confirmResetPassword } = useAuth();

  const [form, setForm] = useState({
    email: searchParams.get('email') || '',
    password: '',
    passwordConfirmation: '',
  });
  const [token] = useState(searchParams.get('token') || '');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setError('Lien de réinitialisation invalide. Veuillez refaire une demande.');
    }
  }, [token]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.passwordConfirmation) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }
    if (form.password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères.');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');

    const result = await confirmResetPassword(
      token,
      form.email,
      form.password,
      form.passwordConfirmation
    );

    setLoading(false);

    if (result.success) {
      setMessage(result.message);
      setTimeout(() => navigate('/connexion'), 3000);
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="auth-page">
      <PageHeader
        title="Nouveau mot de passe"
        subtitle="Créez un mot de passe sécurisé"
      />

      <div className="auth-container">
        <div className="auth-split-layout">
          <div className="auth-left-section">
            <div className="auth-content">
              <h2>Sécurisez votre compte</h2>
              <p className="intro-text">
                Choisissez un mot de passe fort et unique pour protéger votre espace BE TALENTED.
              </p>
              <div className="info-steps">
                <div className="step-item">
                  <div className="step-number">✓</div>
                  <div className="step-text">
                    <h4>Au moins 8 caractères</h4>
                  </div>
                </div>
                <div className="step-item">
                  <div className="step-number">✓</div>
                  <div className="step-text">
                    <h4>Mélangez lettres et chiffres</h4>
                  </div>
                </div>
                <div className="step-item">
                  <div className="step-number">✓</div>
                  <div className="step-text">
                    <h4>Ne réutilisez pas d'ancien mot de passe</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="auth-right-section">
            <div className="auth-card login-card">
              <div className="auth-header compact">
                <h2>Réinitialisation</h2>
              </div>

              {message && (
                <div className="alert alert-success">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                    <polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                  {message} Redirection vers la connexion…
                </div>
              )}

              {error && (
                <div className="alert alert-error">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="15" y1="9" x2="9" y2="15"/>
                    <line x1="9" y1="9" x2="15" y2="15"/>
                  </svg>
                  {error}
                </div>
              )}

              {!message && (
                <form onSubmit={handleSubmit} className="auth-form">
                  <div className="form-group">
                    <label htmlFor="email">Adresse email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                      placeholder="votre.email@exemple.com"
                      disabled={loading}
                    />
                  </div>

                  <PasswordInput
                    id="password"
                    name="password"
                    label="Nouveau mot de passe"
                    value={form.password}
                    onChange={handleChange}
                    required
                    minLength={8}
                    placeholder="Minimum 8 caractères"
                    disabled={loading}
                  />

                  <PasswordInput
                    id="passwordConfirmation"
                    name="passwordConfirmation"
                    label="Confirmer le mot de passe"
                    value={form.passwordConfirmation}
                    onChange={handleChange}
                    required
                    placeholder="Répétez le mot de passe"
                    disabled={loading}
                  />

                  <button
                    type="submit"
                    className="auth-submit-btn"
                    disabled={loading || !token}
                  >
                    {loading ? 'Enregistrement...' : 'Enregistrer le nouveau mot de passe'}
                  </button>

                  <div className="auth-footer">
                    <p>
                      <Link to="/mot-de-passe-oublie">Renvoyer un lien</Link>
                      {' · '}
                      <Link to="/connexion">Se connecter</Link>
                    </p>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReinitialisationMotDePasse;
